import { Dispatch, SetStateAction, useMemo } from "react";
import { ComposeMessageClient } from "../../../../Types/Talent"
import { useUser } from "../../../../Hooks/useUser";
import { useChatContext } from "stream-chat-react";
import { Grid, Divider, Typography } from "@mui/material";
import { Recepient } from "../Recepient";

interface IProps {
    employers: ComposeMessageClient[] | undefined;
    selectedRecepient: ComposeMessageClient | undefined;
    setSelectedRecepient: Dispatch<SetStateAction<ComposeMessageClient | undefined>>
}

const TalentComposeContent = ({ employers, selectedRecepient, setSelectedRecepient }:IProps) => {
    /* ******************** Hooks ******************** */
    debugger
    const { locator } = useUser();
    const { client } = useChatContext();
    /* ******************** Variables ******************** */
    const existingConversations = Object.values(client.activeChannels).map( a => Object.values(a.state.members).filter( m => m?.user_id !== locator).flat()[0]?.user_id)
    const filteredEmployers = useMemo(() => {
        if (employers && existingConversations) {
            return employers.filter( t => !existingConversations.some( e => e === t.locator));
        } else {
            return [];
        }
    }, [employers, existingConversations]);
    /* ******************** Functions ******************** */
    const handleCheck = (user: any) => {
        if (selectedRecepient && selectedRecepient.locator === user.locator){ 
            setSelectedRecepient(undefined);
        } else {
            setSelectedRecepient(user);
        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={'flex'} flexDirection={'column'}>  
            {
                filteredEmployers.length > 0 &&
                <>                  
                    <Grid display={'flex'} flexDirection={'column'} gap={2}>
                        {
                            filteredEmployers.map( (j, idx) => (                                    
                                <Recepient 
                                    key={idx}
                                    user={j} 
                                    selectedRecepient={selectedRecepient} 
                                    handleCheck={handleCheck}
                                />
                            ))
                        }
                    </Grid>
                </>
            }
        </Grid>
    )
}

export default TalentComposeContent